import _invariant           from 'invariant';
import {
  fromJS,
  List,
  Map,
}                           from 'immutable';
import { handleActions }    from 'redux-actions';
import { buildListActions } from '../../../../actions/utils/apiResources/buildSyncActions';
import url                  from '../../../../utils/url';


const DATA_KEY_HYDRA_MEMBER = 'hydra:member';
const DATA_KEY_HYDRA_VIEW   = 'hydra:view';


const buildIdsByPageReducer = (resource) => {

  const listLoadSuccess = buildListActions(resource).success;

  return handleActions(
    {

      [listLoadSuccess]: (state, {payload: {receivedData}}) => {

        _invariant(receivedData, 'Missing receivedData');

        const data = fromJS(receivedData);

        if (!(data.get(DATA_KEY_HYDRA_MEMBER) instanceof List || data.get(DATA_KEY_HYDRA_MEMBER).isEmpty())) {

          console.log('Nothing to update');

          return state;

        }

        const urlString = data.getIn([DATA_KEY_HYDRA_VIEW, '@id']) || data.get('@id');

        const pageId = url.addQueryParams(urlString, {page: 1}, {overwrite: false});

        state = state.set(pageId, data.get(DATA_KEY_HYDRA_MEMBER).map((item) => item.get('@id')));

        return state;

      },

    },

    Map()
  );

};

export default buildIdsByPageReducer;



// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/list/buildIdsByPageReducer.js